import React, { useState, useEffect } from "react";
import styles from "./index.module.scss";
import { Button, DatePicker, Input, Select } from "antd";
import moment from "moment";
import Spinner from "react-bootstrap/Spinner";
import {
  separaetdateAndTime,
  convertDateToString,
} from "../../Helpers/dateFunctions";

import { SvgIcons } from "../../assets/svgIcons";
import { ResetIcon } from "../../assets/Logos/Icons";
import CustomPhoneInputV2 from "../CustomPhoneInputV2/CustomPhoneInputV2";
const { Option } = Select;

const AdminAppointmentFilters = ({ onFilterSubmit, onDownloadRequest,onResetfilter,downloading,downloadavailable,departments, speciality }) => {
  const initialFormData = {
    datePreset: "TODAY",
    fromDate: "",
    toDate: "",
    filterType: "",
  };

  const [formData, setFormData] = useState(initialFormData);
  let [loader, setLoader] = useState(true);
  const [selectedFilterType, setSelectedFilterType] = useState(null);
  // Function to reset formData to initial state
  const resetFormData = () => {
    setFormData(initialFormData);
    setSelectedFilterType(null);
  };

  const handleOnChange = ({ name, value }) => {
    console.log('name', name)
    if (name === "filterType") {
      // Reset form data when filter type changes
      resetFormData();
      onResetfilter();
      setFormData(prevState => ({
        ...prevState,
        [name]: value
      }));
      setSelectedFilterType(value);
    } else if (name === "departments") {
      setFormData({ 
        ...formData, 
        [name]: value.name, 
        departmentId: value.id    
      });
    } else if (name === "speciality") {
      setFormData({ 
        ...formData, 
        [name]: value.name, 
        speciality: value.id    
      });
    } 
    else {
      setFormData({ ...formData, [name]: value });
    }
  };

  
console.log('selectedFilterTypes',selectedFilterType)
  const handleDateRangeChange = ({ name, value }) => {
    setFormData({
      ...formData,
      customDateRange: { ...formData.customDateRange, [name]: value },
    });
  };

  const handleDownload = () => {
    switch (formData.datePreset) {
      case "TODAY":
        return { name: "TODAY" };
      case "CUSTOM":
        return {
          name: "CUSTOM",
          value: {
            fromDate: formData.fromDate,
            toDate: formData.toDate,
          },
        };
      default:
        break;
    }
  };

  const handleSearch = () => {
    switch (formData.filterType) {
      case "BY_DOCTOR":
        return { name: "BY_DOCTOR", value: formData.doctorName };
      case "BY_DATE":
        return { name: "byDate", value: convertDateToString(formData.appointmentDate) };
      case "BY_STATUS":
        return { name: "byStatus", value: formData.AppointmentStatus };
      case "BY_PATIENT":
        return { name: "byName", value: formData.patientName };
      case "BY_NUMBER":
        return {name: "byNumber",value: formData.patientNumber};
      case "BY_EMAIL":
        return {name: "byEmail", value: formData.patientEmail}; 
      case "BY_DEPARTMENT":
        return { name: "byDepartment", value: formData.departments} ;    
      case "BY_SPECIALITY":
        return { name: "byspeciality", value: formData.speciality} ;    
      default:
        break;
    }
  };

  const handleSearchSubmit = () => {
    const _data = handleSearch();
    if (onFilterSubmit) {
      onFilterSubmit(_data);
    }
  };

  const handleDownloadSubmit = () => {
    const _data = handleDownload();
    if (onDownloadRequest) {
     
      onDownloadRequest(_data);
    }
  };

  const handleresetSubmit = () => {
    resetFormData()
    onResetfilter()
  };

 

  console.log("formData",formData)

  console.log("selectedFilterType",selectedFilterType)

  
  return (
    <div className={styles.container}>
      
      <div className={`${styles.section} ${styles.filterSection}`}>
        {/* <h5>Search/Filter Results</h5> */}

        <div className={styles.itemWrap}>
          <div className={styles.itemContainer}>
            
            <Select
            getPopupContainer={trigger => trigger.parentNode}
              width={120}
              
              onChange={(e) => {
                handleOnChange({ name: "filterType", value: e });
              }}
              placeholder="Please select"
              options={[
                // { value: "BY_DOCTOR", label: "By Doctor" },
                { value: "BY_DATE", label: "Date of Request" },
                { value: "BY_STATUS", label: "Appointment Status" },
                { value: "BY_PATIENT", label: "By Patient name " },
                { value: "BY_NUMBER", label: "By Mobile number" },
                { value: "BY_EMAIL", label: "By Email ID"},
                { value: "BY_DEPARTMENT", label: "By Department name" },
                { value: "BY_SPECIALITY", label: "By Speciality name" },
              ]}
              value={formData.filterType!=""?formData.filterType:null}
            />
          </div>
          {
            {
            //   BY_DOCTOR: <DoctorFilter onChange={handleOnChange} />,
              BY_DATE: <DatePickerFilter onChange={handleOnChange} />,
              BY_STATUS: <StatusFilter onChange={handleOnChange} />,
              BY_PATIENT: <PatientFilter onChange={handleOnChange} />,
              BY_NUMBER: <NumberFilter onChange={handleOnChange} />,
              BY_EMAIL: <EmailFilter onChange={handleOnChange} />,
              BY_DEPARTMENT: <DepartmentFilter onChange={handleOnChange} departments={departments} />,
              BY_SPECIALITY: <SpecialityFilter onChange={handleOnChange} departments={speciality} />,
            }[formData.filterType]
          }
          <button onClick={handleSearchSubmit} className={styles.searchBtn} style={{marginLeft: formData.filterType === "BY_DEPARTMENT" || formData.filterType === "BY_SPECIALITY"   ? "75px" : ""}}>
            <SvgIcons.SearchIcon />
          </button>
          {downloadavailable &&
          <button onClick={handleDownloadSubmit} className={styles.searchBtn}>
          
          {downloading? <div
            className="loader"
            style={{ width: "100%", textAlign: "center",minHeight:"5px",marginTop:"5px" }}
          >
            <Spinner
              style={{
                width: "20px",
                height: "20px",
               
                color: "#fff",
              }}
              animation="border"
              role="status"
            >
              <span className="visually-hidden">Loading...</span>
            </Spinner>
            
          </div>:<SvgIcons.DownloadIcon />}
        </button>
        }
        {formData.filterType!="" ?
        <button onClick={handleresetSubmit} className={styles.searchBtn}>
        <ResetIcon />
        </button>
        : null 
        }
       

        </div>
      </div>
    </div>
  );
};

export default AdminAppointmentFilters;

const NumberFilter = ({ onChange }) => {
  const [phoneNumber, setPhoneNumber] = useState("");

  const handleNumberChange = (value, formattedValue, data, event) => {
    const { dialCode, number } = data;
    const formattedMobileNumber = `%2B${dialCode} ${number}`;
    setPhoneNumber(number);
    console.log('mobileNumber', formattedMobileNumber);
    onChange({ name: "patientNumber", value: formattedMobileNumber }); 
  }

  return (
    <div className={styles.itemContainer}style={{marginRight:"30px"}}>
      <CustomPhoneInputV2
        value={phoneNumber}
        onChange={handleNumberChange}
        placeholder="By Number"
        css={{width:"120%", height:"42px",backgroundColor:"white", borderRadius:"6px",fontSize:"14px"}}
      />
    </div>
  );
};

const DateRangePicker = ({ onChange, onSearch }) => {
  const handleChange = (name, value) => {
    onChange({ name, value });
  };

  return (
    <div className={styles.itemWrap}>
      <div className={styles.itemContainer}>
        <DatePicker
          onChange={(value) => {
            handleChange("fromDate", value);
          }}
          format={"DD-MMM-YYYY"}
        />
        <span>to</span>
        <DatePicker
          onChange={(value) => {
            handleChange("toDate", value);
          }}
          format={"DD-MMM-YYYY"}
        />
        <button onClick={onSearch} className={styles.searchBtn}>
          <SvgIcons.DownloadIcon />
        </button>
      </div>
    </div>
  );
};

const DoctorFilter = ({ onChange }) => {
  return (
    <div className={styles.itemContainer}>
      <Select
        onChange={(e) => {
          onChange({ name: "doctorName", value: e });
        }}
        placeholder="Choose Doctor name"
        width={120}
        options={[]}
      />
    </div>
  );
};

const DatePickerFilter = ({ onChange }) => {
  return (
    <div className={styles.itemContainer}>
      <DatePicker
        onChange={(value) => {
          onChange({ name: "appointmentDate", value });
        }}
        placeholder="Select Date"
        format={"DD-MMM-YYYY"}
        getPopupContainer={trigger => trigger.parentNode}
        popupClassName={styles.customDatePickerPopup}
      />
    </div>
  );
};

const StatusFilter = ({ onChange }) => {

  return (
    <div className={styles.itemContainer}>
      <Select
      getPopupContainer={trigger => trigger.parentNode}
        onChange={(e) => {
          onChange({ name: "AppointmentStatus", value: e });
        }}
        placeholder="Select Status"
        width={120}
       
      >
         <Option value="ALL">ALL</Option>
                <Option value="Pending">Pending</Option>
                <Option value="Rejected">Rejected</Option>
                <Option value="Inprogress">In Progress</Option>
                
              </Select>
      
    </div>
  );
};

// const PatientFilter = ({ onChange }) => {

//   return (
//     <div className={styles.itemContainer}>
//       <Input
//         onChange={(e) => {
//           onChange({ name: "patientName", value: e.target.value });
//         }}
//         placeholder="Enter Patient Name"
//       />
//     </div>
//   );
// };

const PatientFilter = ({ onChange }) => {
  const [inputValue, setInputValue] = useState('');

  const handleInputChange = (e) => {
    const inputValue = e.target.value;
    // Regex to allow only alphanumeric characters and spaces
    const regex = /^[a-zA-Z\s]*$/;

    if (regex.test(inputValue) || inputValue === "") { // Allow empty input as well
      setInputValue(inputValue);
      onChange({ name: "patientName", value: inputValue });
    }
  };

  return (
    <div className={styles.itemContainer}>
      <Input
      getPopupContainer={trigger => trigger.parentNode}
        value={inputValue}
        onChange={handleInputChange}
        maxLength={20}
        placeholder="By patient name"
        onKeyPress={(e) => {
          const englishRegex = /^[a-zA-Z\s]*$/;
          if (!englishRegex.test(e.key) && e.key !== 'Backspace' && e.key !== 'Delete') {
            e.preventDefault();
          }
        }}
        onPaste={(e) => {
          const pastedData = e.clipboardData.getData('text/plain');
          const englishRegex = /^[a-zA-Z\s]*$/;
          if (!englishRegex.test(pastedData)) {
            e.preventDefault();
          }
        }}
      />
    </div>
  );
};

const DepartmentFilter = ({ onChange, departments }) => {
  return (
    <div className={styles.itemContainer}>
      <Select
      getPopupContainer={trigger => trigger.parentNode}
        onChange={(value, option) => {
          onChange({ 
            name: "departments", 
            value: {
              id: value,
              name: option.children // This gets the department name
            }
          });
        }}
        placeholder="Select Department"
        width={120}
        style={{width:"140%"}}
      >
        {departments.map((dept) => (
          <Option key={dept.id} value={dept.id}>
            {dept.name}
          </Option>
        ))}
      </Select>
    </div>
  );
};
const SpecialityFilter = ({ onChange, departments }) => {
  return (
    <div className={styles.itemContainer}>
      <Select
      getPopupContainer={trigger => trigger.parentNode}
        onChange={(value, option) => {
          onChange({ 
            name: "speciality", 
            value: {
              id: value,
              name: option.children // This gets the department name
            }
          });
        }}
        placeholder="Select Speciality"
        width={120}
        style={{width:"140%"}}
      >
        {departments.map((dept) => (
          <Option key={dept.id} value={dept.id}>
            {dept.name}
          </Option>
        ))}
      </Select>
    </div>
  );
};

const EmailFilter = ({ onChange, resetFilterAction, patientEmail }) => {
  const [email, setEmail] = useState(patientEmail || '');
  const [errorMessage, setErrorMessage] = useState('');

  const handleEmailChange = (e) => {
    const inputValue = e.target.value;
    const emailRegex = /^[a-zA-Z][a-zA-Z0-9._%+-]*@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

    setEmail(inputValue);
    onChange({ name: 'patientEmail', value: inputValue });

    if (!emailRegex.test(inputValue) && inputValue !== '') {
      setErrorMessage('Please enter a valid email id');
    } else {
      setErrorMessage('');
    }
  };

  return (
    <>
      <div
        className={styles.itemContainer}
        style={{ marginRight: '70px', display: 'block' }}
      >
        <Input
        getPopupContainer={trigger => trigger.parentNode}
          value={email}
          onChange={handleEmailChange}
          placeholder="By Email ID"
          style={{ width: '400px', display: 'flex' }}
          maxLength={35}
          onKeyPress={(e) => {
            const englishRegex = /^[a-zA-Z0-9@\.\s]*$/;
            if (!englishRegex.test(e.key) && e.key !== 'Backspace' && e.key !== 'Delete') {
              e.preventDefault();
            }
          }}
          onPaste={(e) => {
            const pastedData = e.clipboardData.getData('text/plain');
            const englishRegex = /^[a-zA-Z0-9@\.\s]*$/;
            if (!englishRegex.test(pastedData)) {
              e.preventDefault();
            }
          }}
        />
      </div>
      <div style={{ position: 'relative' }}>
        {errorMessage && (
          <p
            style={{
              color: 'red',
              marginLeft: '-270px',
              marginTop: '25px',
              position: 'absolute',
              fontSize:"12px",
              fontWeight:"500"
            }}
          >
            {errorMessage}
          </p>
        )}
      </div>
    </>
  );
};
